import * as yup from 'yup';

import { Room } from 'models/index';
import { Model as RoomModel } from 'models/room/interface';

import { endpoint, EndpointError } from '../endpoint';
import { ValidationShape } from '../validation';

export type UpdateParams = Omit<RoomModel, 'id'> & {
  _id?: RoomModel['_id'];
};
export type UpdateResult = { data: Room.RoomDataAdminResponse };
export type UpdateError = EndpointError;

const VALIDATION_ERROR = {
  REQUIRED: 'נדרש',
  MAX_SYMBOLS: 'נא להזין פחות מ-300 תווים',
};

export const updateParamsSchema = yup.object().shape({
  _id: yup.string(),
  title: yup.string().required(VALIDATION_ERROR.REQUIRED),
  description: yup.string().max(300, VALIDATION_ERROR.MAX_SYMBOLS).required(VALIDATION_ERROR.REQUIRED),
  category: yup.string().required(VALIDATION_ERROR.REQUIRED),
  listenersType: yup.string().required(VALIDATION_ERROR.REQUIRED),
  durationLimit: yup.string().required(VALIDATION_ERROR.REQUIRED),
  status: yup.string().required(VALIDATION_ERROR.REQUIRED),
  date: yup.string().required(VALIDATION_ERROR.REQUIRED),
  admin: yup.array().of(yup.string().nullable()),
  host: yup.array().of(yup.string().required(VALIDATION_ERROR.REQUIRED)),
  speakers: yup.array().of(yup.string().nullable()),
} as unknown as ValidationShape<UpdateParams>);

export const update = endpoint<UpdateParams, UpdateResult, UpdateError>({
  method: 'POST',
  url: () => `/room`,
});
